import { Directive, ElementRef, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { fromEvent } from 'rxjs';

@Directive({
  selector: '[dragmove]'
})
export class DragMoveDirective implements OnInit {
  @Input() dragClassName: string;
  @Output() move = new EventEmitter();
  private isDown = false;
 
  private disX = 0;
  private disY = 0;

  dragElementRef;
  constructor(
    private el: ElementRef
  ) {

  }

  /*  ElementRef是一个服务，它赋予我们通过它的nativeElement属性直接访问 "DOM 元素"的能力  */

  ngOnInit() {

    this.dragElementRef = document.getElementsByClassName(this.dragClassName)[0];


  }

  // 点击事件
  @HostListener('mousedown', ['$event']) onMousedown(event) {
    // 禁止选中close
  
    // if (event.target.className.indexOf('icon-close') !== -1) {
    //   return;
    // }
    this.isDown = true;
    this.disX = event.clientX - this.dragElementRef.offsetLeft;
    this.disY = event.clientY - this.dragElementRef.offsetTop;
  }
  // 监听document移动事件事件
  @HostListener('document:mousemove', ['$event']) onMousemove(event) {
    // 判断该元素是否被点击了。
    if (this.isDown) {
      // 移动中;
 
      const newdisX = event.clientX;
      const newdisY = event.clientY;
      let oLeft = newdisX - this.disX;
      let oTop = newdisY - this.disY;
      if (oLeft < 0) {
        oLeft = 0;
      } else if (oLeft > document.documentElement.clientWidth - this.dragElementRef.offsetWidth) {
        oLeft = document.documentElement.clientWidth - this.dragElementRef.offsetWidth;
      }
      if (oTop < 0) {
        oTop = 0;
      } else if (oTop > document.documentElement.clientHeight - this.dragElementRef.offsetHeight) {
        oTop = document.documentElement.clientHeight - this.dragElementRef.offsetHeight;
      }
      this.dragElementRef.style.left = oLeft + 'px';
      this.dragElementRef.style.top = oTop + 'px';
      this.dragElementRef.style.bottom = 'auto';
      this.dragElementRef.style.right = 'auto';
      this.isMove=true;
    }
  }
 
  isMove=false;

  @HostListener('document:mouseup', ['$event']) onMouseup() {
    // 只用当元素移动过了，离开函数体才会触发。
    if (this.isDown) {
      document.onmousemove = null;
      document.onmouseup = null;
      this.isDown = false;
      
    }

    if(this.isMove){
      this.move.emit({
        top: this.dragElementRef.style.top,
        left:  this.dragElementRef.style.left,
        bottom: this.dragElementRef.style.bottom,
        right:this.dragElementRef.style.right
      });
      this.isMove=false;
    }
  }
}